import { useAuth0 } from "@auth0/auth0-react";
import "./App.css";

function App() {
  const { loginWithRedirect, logout, isAuthenticated, user } = useAuth0();

  return (
    <div className="container">
      {/* HEADER SECTION */}
      <header className="header">
        <h1>Lewis Architecture</h1>

        {/* <div className="auth-controls">
          {!isAuthenticated ? (
            <button className="btn" onClick={() => loginWithRedirect()}>
              Login
            </button>
          ) : (
            <>
              <p className="welcome">Welcome, {user.name}</p>
              <button
                className="btn logout"
                onClick={() =>
                  logout({ logoutParams: { returnTo: window.location.origin } })
                }
              >
                Logout
              </button>
            </>
          )}
        </div> */}

        <p className="intro">
          This site provides instructions, tutorials, and resources for Lewis
          University students and faculty learning software architecture
          concepts through a modular and extensible curriculum.
        </p>
      </header>

      {/* SECTIONS - EASY TO ADD TO */}
      <section className="section">
        <h2>Architecture Design Overview</h2>
        <p>Download the original Architecture Design document:</p>
        <a
          className="download-link"
          href="/files/Architecture Design - Lewis Instructional Software Architecture.pdf"
          download
        >
          Lewis Architecture Design Document
        </a>
      </section>

      <section className="section">
        <h2>Level 0 — Start with the Base Code in React</h2>
        <h4>Skills Acquired:</h4>
        <ul>
            <li>Understand what is going on in the baseline code</li>
            <li>Become more familiar with HTML, CSS, and JS</li>
            <li>See some of the basics of React and learn what makes it different than developing with just HTML, CSS, and JS</li>
            <li>Able to clone and work with code locally from the repo in an IDE</li>
        </ul>

        <h4>Resources</h4>
        <ul>
            <li>Reference to original code from react.dev: <a href="https://react.dev/learn/tutorial-tic-tac-toe">https://react.dev/learn/tutorial-tic-tac-toe</a></li>
            <li>Link to GitHub repo with baseline code: <a href="https://github.com/olivia1117/lewis-tac-toe-base">https://github.com/olivia1117/lewis-tac-toe-base</a></li>
        </ul>

        <h4>Additional References</h4>
        <p>Quick Note: Make sure you brush up on basic HTML, CSS, and JS as well as what HTTP is. You can find resources for this also 
            at the first link below on W3Schools.</p>
        <ul>
            <li>W3Schools What is React? - <a href="https://www.w3schools.com/whatis/whatis_react.asp">https://www.w3schools.com/whatis/whatis_react.asp</a></li>
            <li>React Official Documentation - <a href="https://react.dev/">https://react.dev/</a></li>
            <li>React Tutorial for Beginners - <a href="https://www.freecodecamp.org/news/react-beginner-handbook/">https://www.freecodecamp.org/news/react-beginner-handbook/</a></li> 
        </ul>

	
        <p>Download the written tutorial:</p>
        <a
          className="download-link"
          href="/files/How to start with base tic-tac-toe React code to make new changes.docx"
          download
        >
          How to Start with the Base Code in React and Learn GitHub and Basic Web Development
        </a>
      </section>

      <section className="section">
        <h2>Level 1 — Lewis-Tac-Toe with React + GitHub + Azure</h2>
        <h4>Skills Acquired:</h4>
        <ul>
            <li>Build off previous code to add more features</li>
            <li>Learn how to make a CI/CD development pipeline for putting an application online with Azure</li>
            <li>Continue to learn more about GitHub and how to use it as part of the CI/CD pipeline with GitHub Actions</li>
        </ul>

        <h4>Resources</h4>
        <ul>
            <li>Use your previous code from step 0 for the baseline</li>
            <li>Link to GitHub repo with sample implementation for this step: <a href="https://github.com/olivia1117/lewis-tac-toe">https://github.com/olivia1117/lewis-tac-toe</a></li>
        </ul>

        <h4>Additional References</h4>
        <p>Quick Note: Here are a few other links to better understand Azure, what CI/CD is and how it works, 
            and a few other topics</p>
        <ul>
            <li>YouTube video about different DevOps softwares - <a href="https://www.youtube.com/watch?v=EY1hsh-HCjo">https://www.youtube.com/watch?v=EY1hsh-HCjo</a></li>
            <li>YouTube video overview of React concepts - <a href="https://youtu.be/wIyHSOugGGw?si=tChZZA4aAk_p-cnQ">https://youtu.be/wIyHSOugGGw?si=tChZZA4aAk_p-cnQ</a></li>
            <li>Quick YouTube vide overview of DevOps and CI/CD - <a href="https://www.youtube.com/watch?v=scEDHsr3APg">https://www.youtube.com/watch?v=scEDHsr3APg</a></li> 
        </ul>


        <p>Download the written tutorial:</p>
        <a
          className="download-link"
          href="/files/How to set up a react application online with GitHub and Azure CICD pipeline.docx"
          download
        >
          How to Create a Static Web Application Using React, GitHub, and Azure
        </a>
      </section>

      <section className="section">
        <h2>Level 2 - Lewis-Tac-Toe with Custom Domain and Authentication </h2>
        <h4>Skills Acquired:</h4>
        <ul>
            <li>Build off existing codebase to implement a custom domain name with GoDaddy</li>
            <li>Use Auth0 to add authentication to allow users to have their own profile through an existing
              email account and add more security to the application</li>
            <li>Use React to add a few other features that can only be accessed when a user signs in such as 
              seeing their game stats</li>
        </ul>

        <h4>Resources</h4>
        <ul>
            <li>Use your previous code from step 1 for the baseline</li>
            <li>Link to GitHub repo with sample implementation: <a href="https://github.com/olivia1117/lewis-tac-toe-game">https://github.com/olivia1117/lewis-tac-toe-game</a></li>
        </ul>

        <h4>Additional References</h4>
        <p>Quick Note: Here are a few other links to better understand custom domains, hosting, DNS, and more</p>
        <ul>
            <li>Article from Cloudflare about DNS - <a href="https://www.cloudflare.com/learning/dns/what-is-dns/">https://www.cloudflare.com/learning/dns/what-is-dns/</a></li>
            <li>YouTube video about the difference between web and domain hosting - <a href="https://www.youtube.com/watch?v=wXyQiBy0kjk">https://www.youtube.com/watch?v=wXyQiBy0kjk</a></li>
            <li>YouTube video with another explanation of DNS - <a href="https://www.youtube.com/watch?v=mpQZVYPuDGU">https://www.youtube.com/watch?v=mpQZVYPuDGU</a></li> 
            <li>Article from AWS about CORS - <a href="https://aws.amazon.com/what-is/cross-origin-resource-sharing/">https://aws.amazon.com/what-is/cross-origin-resource-sharing/</a></li>
            <li>Article from Dev.to about Authentication and Authorization - <a href="https://dev.to/divine_nnanna2/authentication-and-authorization-techniques-in-modern-web-applications-2okl">https://dev.to/divine_nnanna2/authentication-and-authorization-techniques-in-modern-web-applications-2okl</a></li>
        </ul>
        <p>Download the written tutorials:</p>
        <a
          className="download-link"
          href="/files/How to add a domain name to a cloud provider website.docx"
          download
        >
          How to Add a Domain Name to a Cloud Provider Website
        </a>
        <br/>
        <a
          className="download-link"
          href="/files/How to add 3rd party authentication with Auth0.docx"
          download
        >
          How to Add Third Party Authentication with Auth0  

        </a>
      </section>

      <section className="section">
        <h2>Level 3 - Lewis-Tac-Toe with Node.js Server and MongoDB Atlas</h2>
        <h4>Skills Acquired:</h4>
        <ul>
            <li>Use work from level 2 to add functionality for a database and a server</li>
            <li>Learn how to set up a separate Node.js server through Azure and GitHub CI/CD pipeline</li>
            <li>Learn how to use MongoDB as a NoSQL DB to track login times/history and display them to the React web app</li>
        </ul>

        <h4>Resources</h4>
        <ul>
            <li>Use your previous code from step 2 for the baseline</li>
            <li>Link to GitHub repo with sample implementation: <a href="https://github.com/olivia1117/lewis-tac-toe-game">https://github.com/olivia1117/lewis-tac-toe-game</a></li>
        </ul>

        <p>Download the written tutorial:</p>
        <a
          className="download-link"
          href="/files/How to add a server-side NoSQL DB.docx"
          download
        >
          How to Add a Server-Side NoSQL Database with Node.js and MongoDB Atlas
        </a>
      </section>

      <section className="section">
        <h2>Level 4 - Lewis-Tac-Toe with Server-Side File Storage and Sharing</h2>
        <h4>Skills Acquired:</h4>
        <ul>
            <li>Use work from level 3 to build on previous database and server functionality to now allow for file uploads, 
              downloads, display, and storage</li>
            <li>Continue to visualize and understand how the client and server model works to communicate with each other and to a database</li>
        </ul>

        <h4>Resources</h4>
        <ul>
            <li>Use your previous code from step 3 for the baseline</li>
            <li>Link to GitHub repo with sample implementation: <a href="https://github.com/olivia1117/lewis-tac-toe-game">https://github.com/olivia1117/lewis-tac-toe-game</a></li>
        </ul>
        <p>Download the written tutorial:</p>
        <a
          className="download-link"
          href="/files/How to add server-side file storage and sharing.docx"
          download
        >
          How to Add a Server-Side File Storage and Sharing System with Node.js and MongoDB GridFS
        </a>
      </section>

    </div>
  );
}

export default App;
